<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface DataListItemDescriptionProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '../../../lib/utils'
  const props = defineProps<DataListItemDescriptionProps>()
</script>

<template>
  <div :class="cn('text-muted-foreground truncate text-sm', props.class)">
    <slot />
  </div>
</template>
